import awardsKeyboardImg from "./awards_keyboard.png";
import awardsLogoImg from "./awards_logo.png";

export const AWARDS_IMG_KEYBOARD = {
  src: awardsKeyboardImg,
  alt: "Devportal Awards DX Design",
};

export const AWARDS_IMG_LOGO = {
  src: awardsLogoImg,
  alt: "Devportal Awards Logo",
};
